import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { formatDateAt } from "simplydo/core/dates";
import { challengeImage } from "simplydo/core/images";
import { OpenAPI } from "simplydo/interfaces";

import util from "utils/utils";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";

type ChallengeFeedItemProps = {
  item: FeedItemOfType<"challenge"> | FeedItemOfType<"discoverChallenge">;
};

const isPreparedUser = (
  subject: unknown,
): subject is OpenAPI.Schemas["PreparedUser"] =>
  !!subject && typeof subject === "object" && "profile" in subject;

const ChallengeFeedItem = ({ item }: ChallengeFeedItemProps) => {
  const { t } = useTranslation();
  const postedBy = "postedBy" in item ? item.postedBy : undefined;
  const isAnonymous = item.postedByType === "anonymous";
  const action = item.publishedAt ? "opened" : "created";
  const date = item.publishedAt || item.createdAt;

  return (
    <FeedItem>
      <FeedItemIcon src={challengeImage(item)} />
      <FeedItemContent>
        <FeedItemMessage>
          {!isAnonymous && postedBy ? (
            isPreparedUser(postedBy) ? (
              <>
                <b>
                  <UserChip user={postedBy} compact="very" />
                </b>{" "}
              </>
            ) : (
              <>
                <b>{(postedBy as { name?: string }).name}</b>{" "}
              </>
            )
          ) : (
            <>
              <b>{t("generic.anonymous")}</b>{" "}
            </>
          )}
          <span>
            {action} <Link to={util.challengeLink(item)}>{item.name}</Link>.
          </span>
        </FeedItemMessage>
        <FeedItemDate>{formatDateAt(date)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default ChallengeFeedItem;
